export const trackGuestOrderTrackSuccess = (trackingType) => {
    return {
        event: 'guest order manage success',
        effect: 'guest order management',
        category: {
            primaryCategory: 'guest order management',
            subCategory: trackingType // "track order|create return|track return"
        }
    }
}

export const trackGuestOrderTrackError = (trackingType, error) => {
    return {
        event: 'guest order manage error',
        effect: 'guest order management',
        category: {
            primaryCategory: 'guest order management',
            subCategory: trackingType // "track order|create return|track return"
        },
        attributes: {
            error: error
        }
    }
}

export const mapTypeToValue = (type) => typeObject[type]

const typeObject = {
    trackOrder: 'track order',
    trackReturn: 'track return',
    createReturn: 'create return'
}
